import { appQueryClient } from '../../../../provider'

export const modulationContractsReportCachekeys = {
  one: (modulation_user_contract_id: number) => [
    'modulation_user_contracts_report',
    modulation_user_contract_id
  ]
}

export const modulationContractReportInvalidations = {
  invalidateReport: (modulation_user_contract_id: number) => {
    appQueryClient.invalidateQueries({
      queryKey: modulationContractsReportCachekeys.one(
        modulation_user_contract_id
      )
    })
  }
}
